
import React from "react"
import SimpleImageSlider from "react-simple-image-slider"
import '../ProductDetail.css';
// import { images } from "../ax";

export default function Slider(props){



  //  const images = 
  // [
  //   {
  //     url: "/images/16- Podfriendly - Cartoon/Hipster Cricket.png",
  //     "Alt": "2",
  //     "id": 21
  //   },
  //   {
  //     url: "/images/16- Podfriendly - Cartoon/Hipster Field Hockey.png",
  //     "Alt": "2",
  //     "id": 22
  //   }
  // ]
  const images = [
    { url:'/images/KIDS/26.png',"Alt":"3","id":1},
    { url:'/images/KIDS/27.png',"Alt":"3","id":2},
    { url:'/images/KIDS/22.png',"Alt":"3","id":3},
    { url:'/images/KIDS/23.png',"Alt":"3","id":4},
    { url:'/images/KIDS/24.png',"Alt":"3","id":5},
    // { url:'/images/KIDS/p6.png',"Alt":"3","id":6},
   { url:'/images/KIDS/25.png',"Alt":"2","id":7},
  //  { url:'/images/2.png',"Alt":"3","id":8},
  //  { url:'/images/3.png',"Alt":"2","id":9},
  //  { url:'/images/4.png',"Alt":"4","id":10},
  //  { url:'/images/5.png',"Alt":"2","id":11},
  //  { url:'/images/6.png',"Alt":"2","id":12},
  //  { url:'/images/7.png',"Alt":"6","id":13},
  //  { url:'/images/8.png',"Alt":"2","id":14},
  //  { url:'/images/9.png',"Alt":"2","id":15},
  //  { url:'/images/10.png',"Alt":"12","id":16},
  //  { url:'/images/11.png',"Alt":"2","id":17},
  //  { url:'/images/12.png',"Alt":"2","id":18},
  //  { url:'/images/13.png',"Alt":"22","id":19},
  //  { url:'/images/14.png',"Alt":"2","id":20},
  //  { url:'/images/15.png',"Alt":"2","id":21},
  ]
    return(
        
  <SimpleImageSlider 
  
  width={props.width}
  height={props.height}
  images={images}
  // borderRadius={18}
  showBullets={false}
  showNavs={false}
  slideDuration={3}
  autoPlay={true}
  bgColor=""
  // "#f4f4f4"
  // navStyle={2}
  style={{
    // border: '1px solid #f4f4f4',
    borderRadius: '5px',
    // boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
    objectFit: "fill",
  }}
//   navStyle={{
//     backgroundColor: 'rgba(0, 0, 0, 0.5)',
//     color: 'white',
//     padding: '10px 15px',
//     borderRadius: '5px',
//   }}
//   bulletStyle={{
//     backgroundColor: 'gray',
//     width: '10px',
//     height: '10px',
//     margin: '0 5px',
//     borderRadius: '50%',
//   }}
//   activeBulletStyle={{
//     backgroundColor: 'white',
//   }}

  
  
  
  
  />


    )

}
///vagty axa ok shod ino estefade kon:

// import React, { useState, useEffect } from "react";
// import SimpleImageSlider from "react-simple-image-slider";
// import '../ProductDetail.css';
// import { images } from '../ax';

// export default function Slider(props) {

//   const [randomImages, setRandomImages] = useState([]);

  
//   const shuffleArray = (array) => {
//     const shuffled = [...array];
//     for (let i = shuffled.length - 1; i > 0; i--) {
//       const j = Math.floor(Math.random() * (i + 1));
//       [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];  
//     }
//     return shuffled;
//   };

//   const getRandomImages = (array, num) => {
//     const shuffledImages = shuffleArray(array);
//     return shuffledImages.slice(0, num);  


//   useEffect(() => {
//     const images2 = getRandomImages(images, 20); 
//     setRandomImages(images2); 
//   }, []);


//   if (randomImages.length === 0) {
//     return null; 
//   }
// console.log(randomImages)
//   return (
//     <SimpleImageSlider
//       width={props.width}
//       height={props.height}
//       images={randomImages.map(item => ({
//         url: item.src, 
//         Alt: item.Alt,  
//         id: item.id   
//       }))} 
//       showBullets={false}
//       showNavs={false}
//       slideDuration={3}
//       autoPlay={true}
//       bgColor=""
//       style={{
//         borderRadius: '5px',
//       }}
//     />
//   );
// }
